/* DUKA — Public web page enhancements
   - Inject DUKA footer on public pages (except landing/auth which have their own)
   Note: /login and /signup are now fully custom DUKA pages — no patching needed. */

(function () {
	function isCustomPage() {
		var p = window.location.pathname;
		// Strip query string
		var qIdx = p.indexOf("?");
		if (qIdx >= 0) p = p.substring(0, qIdx);
		var customPaths = [
			"/",
			"/index",
			"/login",
			"/signup",
			"/signup-thanks",
			"/about",
			"/pricing",
			"/features",
			"/contact",
			"/privacy",
			"/terms",
			"/cookies",
			"/first-login",
			"/forgot-password",
			"/update-password",
			"/status",
			"/reports",
			// In-app shopkeeper surfaces — already have the in-app inline footer
			"/today",
			"/petty",
			"/damage",
		];
		if (customPaths.indexOf(p) !== -1) return true;
		// In-app prefixes
		var customPrefixes = [
			"/app",
			"/account",
			"/today/",
			"/cash/",
			"/bank/",
			"/outlet/",
			"/item/",
			"/customer/",
		];
		for (var i = 0; i < customPrefixes.length; i++) {
			if (p.indexOf(customPrefixes[i]) === 0) return true;
		}
		return false;
	}

	function injectFooter() {
		if (isCustomPage()) return;
		// The signed-in DUKA app shell (templates/duka_app.html) renders its own
		// chrome and must never carry the marketing footer — detect it structurally
		// via its #dkapp root instead of maintaining an ever-growing page list here.
		if (document.getElementById("dkapp")) return;
		if (document.querySelector(".duka-footer")) return;

		var footer = document.createElement("footer");
		footer.className = "duka-footer";
		footer.innerHTML =
			'<div class="duka-footer-inner">' +
			'<div class="duka-footer-grid">' +
			"<div>" +
			'<a href="/" class="duka-footer-brand">' +
			'<img src="/assets/duka/duka.png" alt="DUKA">' +
			"<span>DUKA</span>" +
			"</a>" +
			'<p class="duka-footer-tagline">Merchant cash-control software for retail businesses. Track, report, and grow with confidence.</p>' +
			'<div class="duka-footer-built">' +
			'<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>' +
			"Built in Kigali" +
			"</div>" +
			"</div>" +
			'<div class="duka-footer-col">' +
			"<h4>Product</h4>" +
			"<ul>" +
			'<li><a href="/features">Features</a></li>' +
			'<li><a href="/pricing">Pricing</a></li>' +
			'<li><a href="/faq">FAQ</a></li>' +
			"</ul>" +
			"</div>" +
			'<div class="duka-footer-col">' +
			"<h4>Company</h4>" +
			"<ul>" +
			'<li><a href="/about">About</a></li>' +
			'<li><a href="/contact">Contact</a></li>' +
			"</ul>" +
			"</div>" +
			'<div class="duka-footer-col">' +
			"<h4>Legal</h4>" +
			"<ul>" +
			'<li><a href="/privacy">Privacy</a></li>' +
			'<li><a href="/terms">Terms</a></li>' +
			'<li><a href="/cookies">Cookies</a></li>' +
			"</ul>" +
			"</div>" +
			"</div>" +
			'<div class="duka-footer-bottom">' +
			"<p>© 2026 DUKA. All rights reserved.</p>" +
			'<div class="duka-footer-status">' +
			'<span class="duka-status-dot"></span>' +
			"All systems operational" +
			"</div>" +
			"</div>" +
			"</div>";

		document.body.appendChild(footer);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", injectFooter);
	} else {
		injectFooter();
	}
})();
